import { DeviceBreakpointsType } from '@kubit/web-ui-components/types/breakpoints';
import { FONT_WEIGHT } from '../../foundations/typography';
import { TextVariantType } from '../variants';
export const commonStyles = (FOUNDATIONS, FONT) => ({
    container: {
        display: 'flex',
        flex_direction: 'column',
        gap: FOUNDATIONS.spacing_150,
        background_color: FOUNDATIONS.color_exception_neutral_bg_850,
    },
    containerFocusVisible: {
        border_radius: FOUNDATIONS.radius_200,
    },
    inputContainer: {
        border_radius: FOUNDATIONS.radius_comp_forms_inputcurrencylarge_radiussize,
        border_style: 'solid',
        border_width: FOUNDATIONS.border_50,
        border: FOUNDATIONS.color_neutral_border_150,
        padding: `${FOUNDATIONS.spacing_200} ${FOUNDATIONS.spacing_250}`,
        background_color: FOUNDATIONS.color_comp_forms_input_bg,
        cursor: 'pointer',
    },
    affixInputParentContainer: {
        position: 'relative',
        display: 'flex',
        gap: FOUNDATIONS.spacing_200,
        justify_content: 'center',
    },
    affixContainer: {
        display: 'inline-flex',
        justify_content: 'center',
        align_items: 'center',
        border_radius: FOUNDATIONS.radius_200,
        background_color: 'transparent',
    },
    affix: {
        font_variant: TextVariantType.FONT_HEADING_300,
        font_weight: FONT_WEIGHT.font_weight_600,
        color: FOUNDATIONS.color_comp_forms_input_filled_font,
    },
    helpMessageContainer: {
        align_self: 'center',
    },
    helpMessage: {
        font_weight: FONT_WEIGHT.font_regular,
        color: FOUNDATIONS.color_comp_forms_input_secondaryfont,
        font_variant: TextVariantType.FONT_PARAGRAPH_350,
    },
    inputTypography: {
        font_weight: FONT_WEIGHT.font_weight_600,
        font_size: FONT.font_heading_300[DeviceBreakpointsType.DESKTOP].font_size,
        line_height: FONT.font_heading_300[DeviceBreakpointsType.DESKTOP].line_height,
        color: FOUNDATIONS.color_comp_forms_input_filled_font,
    },
    input: {
        cursor: 'pointer',
        box_sizing: 'border-box',
    },
    placeholder: {
        font_weight: FONT_WEIGHT.font_weight_600,
        font_size: FONT.font_heading_300[DeviceBreakpointsType.DESKTOP].font_size,
        line_height: FONT.font_heading_300[DeviceBreakpointsType.DESKTOP].line_height,
        color: FOUNDATIONS.color_comp_forms_input_secondaryfont,
    },
    label: {
        font_variant: TextVariantType.FONT_PARAGRAPH_350,
        font_weight: FONT_WEIGHT.font_regular,
        color: FOUNDATIONS.color_comp_forms_input_filled_font,
    },
    labelContainer: {
        display: 'flex',
        justify_content: 'center',
    },
});
export const defaultEmptyFontCommonStyles = (FOUNDATIONS, FONT) => ({
    inputTypography: {
        ...commonStyles(FOUNDATIONS, FONT).inputTypography,
        color: FOUNDATIONS.color_comp_forms_input_empty_font,
    },
    affix: {
        ...commonStyles(FOUNDATIONS, FONT).affix,
        color: FOUNDATIONS.color_comp_forms_input_empty_font,
    },
    placeholder: {
        font_weight: FONT_WEIGHT.font_weight_600,
        font_size: FONT.font_heading_300[DeviceBreakpointsType.DESKTOP].font_size,
        line_height: FONT.font_heading_300[DeviceBreakpointsType.DESKTOP].line_height,
        color: FOUNDATIONS.color_comp_forms_input_secondaryfont,
    },
});
export const disabledFilledCommonStyles = (FOUNDATIONS, FONT) => ({
    ...commonStyles(FOUNDATIONS, FONT),
    inputContainer: {
        ...commonStyles(FOUNDATIONS, FONT).inputContainer,
        background_color: FOUNDATIONS.color_accent_disabled_bg_100,
        border: FOUNDATIONS.color_accent_disabled_border_100,
        cursor: 'default',
    },
    inputTypography: {
        ...commonStyles(FOUNDATIONS, FONT).inputTypography,
        color: FOUNDATIONS.color_accent_disabled_font_50,
    },
    helpMessageContainer: {
        ...commonStyles(FOUNDATIONS, FONT).helpMessageContainer,
        cursor: 'default',
    },
    affix: {
        ...commonStyles(FOUNDATIONS, FONT).affix,
        color: FOUNDATIONS.color_accent_disabled_font_50,
    },
    label: {
        ...commonStyles(FOUNDATIONS, FONT).label,
        color: FOUNDATIONS.color_accent_disabled_font_50,
    },
    helpMessage: {
        ...commonStyles(FOUNDATIONS, FONT).helpMessage,
        color: FOUNDATIONS.color_accent_disabled_font_50,
    },
    placeholder: {
        ...commonStyles(FOUNDATIONS, FONT).placeholder,
        color: FOUNDATIONS.color_accent_disabled_font_50,
    },
});
export const commonErrorStyles = (FOUNDATIONS, FONT) => ({
    errorMessageContainer: {
        display: 'flex',
        flex_direction: 'row',
        column_gap: FOUNDATIONS.spacing_100,
    },
    errorMessage: {
        font_variant: TextVariantType.FONT_PARAGRAPH_350,
        font_weight: FONT_WEIGHT.font_regular,
        color: FOUNDATIONS.color_feedback_error_font_50,
    },
    errorMessageIcon: { width: FOUNDATIONS.size_250, height: FOUNDATIONS.size_250 },
});
//# sourceMappingURL=commonStyles.js.map